/**
 * tip: 通用数据管理  用于限制通用数据频繁请求
 */
import Vue from 'vue';

/* 判断对象值是否相同 */
function isObjectValueEqual(a, b) {
  // 判断两个对象是否指向同一内存，指向同一内存返回true
  if (a === b) return true
  // 获取两个对象键值数组
  let aProps = Object.getOwnPropertyNames(a)
  let bProps = Object.getOwnPropertyNames(b)
  // 判断两个对象键值数组长度是否一致，不一致返回false
  if (aProps.length !== bProps.length) return false
  // 遍历对象的键值
  for (let prop in a) {
    // 判断a的键值，在b中是否存在，不存在，返回false
    if (b.hasOwnProperty(prop)) {
      // 判断a的键值是否为对象，是则递归，不是对象直接判断键值是否相等，不相等返回false
      if (typeof a[prop] === 'object') {
        if (!isObjectValueEqual(a[prop], b[prop])) return false
      } else if (a[prop] !== b[prop]) {
        return false
      }
    } else {
      return false
    }
  }
  return true
}
/* 判断请求时间和参数是否相同 */
function isRequest(obj, data, time) {
  if (!obj) return false
  if (new Date().getTime() - (obj.time || 0) > time) return false
  if (!isObjectValueEqual(data, obj.data)) return false
  return true
}

export default {
  namespaced: true,
  state: {
    requestDatas: {}, //记录请求时间 {time:xxxx,data:{}}
    requestUrls: {
      cateList: '/admin/cate/index', //平台商品分类
      managerList: '/admin/user/getUser?role1', //管理员列表
      salesmenList: '/admin/user/getUser?role2', //业务员列表
      buyerList: '/admin/user/getUser?role3', //平台采购员
      sorterList: '/admin/user/getUser?role4', //分拣员列表
      supplierList: '/admin/user/getSupplier', //供应商
      storeList: '/admin/warehouse/index', //仓库列表
      routeList: '/admin/delivery_circuit/get_list', //线路列表
      deliveryList: '/admin/adminer/index', //送货员列表
      customerList: '/admin/customer/index', //客户列表 企业客户列表
      polygonList: '/admin/user_district/index', //商圈列表
      basketList: '/admin/basket/index', //周转筐列表
      bankList: '/admin/bank/index', //银行卡
      inOutList: '/admin/payment/getPaymentCateTree', // 收支类目
      labelList: '/admin/customer/get_label_list', // 客户标签
      reportList: '/admin/cate/getDictListByType', // 农残类型
      deviceList: '/admin/device/getDeviceType', // 设备类型
      deviceCodeList: '/admin/device/getDeviceCjxh', // 厂商+型号
      departmentList: '/admin/department/departmentTree', // 组织架构树
      roleList: '/admin/department/getRoleSelect', // 新角色列表 权限
      sourceTypeList: '/admin/language/source_type_tree', // 平台翻译 来源 + 类型
    }, //接口
    cateList: [], //平台商品分类
    managerList: [],
    salesmenList: [], //业务员列表
    buyerList: [], //平台采购员
    sorterList: [], //分拣员列表
    supplierList: [], //供应商
    storeList: [], //仓库列表
    routeList: [], //线路列表
    deliveryList: [], //送货员列表
    customerList: [], //客户列表
    polygonList: [], //商圈列表
    basketList: [], //周转筐列表
    bankList: [], // 银行卡
    inOutList: [], // 收支类目
    labelList: [], // 客户标签
    reportList: [], // 农残类型
    deviceList: [], // 设备类型
    deviceCodeList: [],
    departmentList: [],
    roleList: [],
    sourceTypeList: []
  },
  getters: {
    storeListMerge(state) {
      let list = [];
      state.storeList.forEach(item => {
        item.area.forEach(itm => {
          list.push({
            name: item.name + '-' + itm.area_name,
            id: item.id + '-' + itm.id
          })
        })
      })
      return list
    }
  },
  mutations: {
    SET_STATE_PUSH(state, params) {
      state[params.name].push(params.value)
    },
    SET_STATE(state, params) {
      state[params.name] = params.value
    },
    SET_TIMES(state, params) {
      state.requestDatas[params.name] = params.value;
    },
  },
  actions: {
    /* 获取数据 */
    getStoreDatas(context, {
      list,
      param = "",
      isData = false,
      time = 600000
    }) {
      return new Promise((resolve, reject) => {
        if (!list) {
          reject()
          return
        }
        if (!param) {
          switch (list) {
            case 'cateList':
              param = {
                type: 1,
                is_tree: 1,
              };
              break;
            case 'managerList':
              param = {
                role: 1, //角色
              };
              break;
            case 'salesmenList':
              param = {
                role: 2, //角色
              };
              break;
            case 'buyerList':
              param = {
                role: 3, //角色
              };
              break;
            case 'sorterList':
              param = {
                role: 4, //角色
              };
              break;
            case 'deliveryList':
              param = {
                role: 5, //角色
              };
              isData = true;
              break;
            case 'supplierList':
              param = {};
              break;
            case 'routeList':
              param = {};
              break;
            case 'labelList':
              param = {};
              break;
            case 'customerList':
              param = {
                all: 1, //1所有客户
                user_type: 0, // 0单位 1个人 2代收点
                is_stop: 0, // 1 停用 0正常
              };
              isData = true;
              break;
            case 'reportList':
            case 'sourceTypeList':
              param = {};
              break;
            default:
              param = {
                page: 1,
                limit: 9999
              };
              isData = true;
          }
        }
        //如果数组有值 && 上次请求时间未超过 time && 请求参数一致  则直接返回
        if (context.state[list].length > 0 && isRequest(context.state.requestDatas[list], param, time)) {
          resolve(context.state[list])
          return
        }
        context.dispatch('request', {
          url: context.state.requestUrls[list],
          list: list,
          data: param,
        }).then((res) => {
          let value = (isData ? res.data.data : res.data);
          context.commit('SET_STATE', {
            name: list,
            value: value
          })
          resolve(value)
        }).catch(reject)
      })
    },
    request(context, {
      url,
      list,
      data = {}
    }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.request({
          url: url,
          data: JSON.parse(JSON.stringify(data)), //防止记录请求参数时 增加token等参数
          is_public: true,
          complete: (res) => {
            if (res.error_code == 0) {
              context.commit('SET_TIMES', {
                name: list,
                value: {
                  time: new Date().getTime(),
                  data
                }
              })
              resolve(res)
            } else {
              Vue.prototype.$message.error(res.error_msg);
              reject(res)
            }
          }
        })
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/datas.js